import React, { useState } from 'react';
import { Mail as EmailIcon } from 'react-feather';
import Dialog from '../../components/Dialog';
import SaveConfiguration from './SaveConfiguration';
import { useUserContext } from '@magento/peregrine/lib/context/user';
import dialogClasses from '../../components/Dialog/dialog.module.css';

const ShareByEmail = props => {
    const { classes, title, ...rest } = props;

    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [{ currentUser }] = useUserContext();

    const showSaveConfig = e => {
        e.preventDefault && e.preventDefault();
        setIsDialogOpen(true);
    };

    const hideSaveConfig = e => {
        e.preventDefault && e.preventDefault();
        setIsDialogOpen(false);
    };

    return (
        <>
            <button onClick={showSaveConfig} className={classes.button}>
                <EmailIcon className={classes.icon} />
                {_('Send by email')}
            </button>

            <Dialog
                isOpen={isDialogOpen}
                onConfirm={hideSaveConfig}
                onCancel={hideSaveConfig}
                showCancelButton={false}
                confirmText={_('Close')}
                title={title || _('Share by email')}
                classes={{ root_open: dialogClasses.above }}
            >
                <SaveConfiguration userEmail={currentUser.email} {...rest} />
            </Dialog>
        </>
    );
};

export default ShareByEmail;
